module.exports = __webpack_public_path__ + "static/media/prof1.c8797277.png";